import { render, staticRenderFns } from "./EditAppVersionUpdates.vue?vue&type=template&id=60364c0d&scoped=true"
import script from "./EditAppVersionUpdates.vue?vue&type=script&lang=ts"
export * from "./EditAppVersionUpdates.vue?vue&type=script&lang=ts"
import style0 from "./EditAppVersionUpdates.vue?vue&type=style&index=0&id=60364c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60364c0d",
  null
  
)

export default component.exports